import api from "../../apiConfig/api_config"
import { Post,Get } from '../base/baseAjax'
let loginApi = (param) => {
 return Post({
    url: api.login,
    bodyParam: param
  })
}
let loginOut= ({token}) => {
    return Get({
      url: api.loginOut,
      PathParam: {
        token: token
      }
    })
  }
  let getCode = ({name}) => {
     return Get({
       url: api.code,
       PathParam: {
          name: name
       }
     })
  }
  let checkCode = (param) => {
    return Post({
      url: api.checkCode,
      bodyParam: param
    })
  }
  let editPwd = (param) => {
    return Post({
      url: api.editPwd,
      bodyParam: param
    })
  }
  let verification = ({name}) => {
    return Get({
      url: api.verification,
      PathParam: {
        name: name
      }
    })
  }
  let getVCode = () => {
    return Get({
      url: api.getCode
    })
  }
  let sys = () => {
    return Get({
      url: api.sys
    })
  }
  let qywxlogin = (code) => {
    return Get({
      url: api.qycode+"/"+code
    })
  }
  let qywxCode = (phone) => {
    return Get({
      url: api.codewx+ "/"+phone
    })
  }
  let isHaseToken = (token) => {
    return Get({
      url: api.haseToken + "/" + token
    })
  }
  let codeImg=()=>{
    return Get({
      url:api.codeImage
    })
  }
  let getEmailUrl=()=>{
    return Get({
      url:api.loginEmial
    })
  }
export default {
  loginApi: loginApi,
  loginOut: loginOut,
  getCode: getCode,
  checkCode: checkCode,
  editPwd: editPwd,
  verification:verification,
  getVCode: getVCode,
  sys:sys,
  qywxlogin,
  qywxCode,
  isHaseToken,
  codeImg,
  getEmailUrl
}



// WEBPACK FOOTER //
// ./src/services/login/login.js